export default "__VITE_ASSET__419acccd__"